import { BASE_BACKEND_URL, CLIENT_TYPE } from '@/requests/constants';
import { useMutation } from '@tanstack/react-query';
import type { CreateErrandPayload, CreateErrandResponse } from '../types';

interface CreateErrandOptions {
  readonly customerId: string;
}

export function useCreateErrand({ customerId }: CreateErrandOptions) {
  return useMutation({
    mutationFn: async (payload: CreateErrandPayload) => {
      const res = await fetch(
        `${BASE_BACKEND_URL}/errands/generalerrands/reporting/anonymous/generalerrand/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-PIGELLO-CUSTOMER-ID': customerId,
            'X-PIGELLO-CLIENT-TYPE': `${CLIENT_TYPE},pigelloanon,1.0.0`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw errorData;
      }

      const data: CreateErrandResponse = await res.json();
      return data;
    },
  });
}
